// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/login-background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-size: cover;
  min-height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 40px;
  box-sizing: border-box;
}
@media (max-width: 576px) {
  .login-page {
    padding: 16px;
  }
}
.login-page:before {
  content: "";
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  backdrop-filter: blur(5px) brightness(50%);
  background: transparent;
}

.login {
  background: #fff;
  width: 520px;
  max-width: 100%;
  border-radius: 10px;
  padding: 32px 52px;
  z-index: 3;
  position: relative;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.5);
  box-sizing: border-box;
}
@media (max-width: 576px) {
  .login {
    padding: 32px;
  }
}

.login__logo-container {
  text-align: center;
  margin-bottom: 40px;
}

.login__logo {
  max-width: 80%;
}

.buttons-container {
  display: flex;
  width: 100%;
  align-items: center;
}
@media (max-width: 576px) {
  .buttons-container {
    flex-direction: column;
  }
}

.buttons-container__row {
  flex-grow: 1;
}
@media (max-width: 576px) {
  .buttons-container__row {
    width: 100%;
    text-align: center;
  }
}
@media (max-width: 576px) {
  .buttons-container__row ~ .buttons-container__row {
    margin-top: 24px;
  }
}

.login-page__footer {
  position: relative;
  z-index: 2;
  padding: 24px;
}

.login-page__footer__text {
  color: #fff;
  text-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
  text-align: center;
}
@media (max-width: 576px) {
  .login-page__footer__text {
    font-size: 14px;
  }
}

.mirakl-button {
  padding-bottom: 1rem;
  display: flex;
  flex-direction: column;
}
.mirakl-button__row {
  padding-top: 1rem;
}
.mirakl-button .button--mirakl {
  background-color: #1563a3;
  width: 100%;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/components/Layout/GuestLayout.scss","webpack://./src/utils/scss/_mixins.scss"],"names":[],"mappings":"AAGA;EACE,mDAAA;EACA,2BAAA;EACA,sBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;AAFF;ACGE;EDXF;IAaI,aAAA;EADF;AACF;AAGE;EACE,WAAA;EACA,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,0CAAA;EACA,uBAAA;AADJ;;AAIA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,0CAAA;EACA,sBAAA;AADF;ACzBE;EDiBF;IAYI,aAAA;EAAF;AACF;;AAEA;EACE,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AACF;AC7CE;EDyCF;IAMI,sBAAA;EAEF;AACF;;AAAA;EACE,YAAA;AAGF;ACtDE;EDkDF;IAII,WAAA;IACA,kBAAA;EAIF;AACF;AC5DE;ED0DA;IAEI,gBAAA;EAIJ;AACF;;AAAA;EACE,kBAAA;EACA,UAAA;EACA,aAAA;AAGF;;AADA;EACE,WAAA;EACA,2CAAA;EACA,kBAAA;AAIF;AC7EE;EDsEF;IAMI,eAAA;EAKF;AACF;;AAHA;EACE,oBAAA;EACA,aAAA;EACA,sBAAA;AAMF;AALE;EACE,iBAAA;AAOJ;AAJE;EACE,yBAAA;EACA,WAAA;EACA,WAAA;AAMJ","sourcesContent":["@import \"./../../utils/scss/variables\";\n@import \"./../../utils/scss/mixins\";\n\n.login-page {\n  background: url(./../../assets/images/login-background.png);\n  background-position: center;\n  background-size: cover;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  padding: 40px;\n  box-sizing: border-box;\n\n  @include sm {\n    padding: 16px;\n  }\n\n  &:before {\n    content: \"\";\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: z(\"loginOverlay\");\n    backdrop-filter: blur(5px) brightness(50%);\n    background: transparent;\n  }\n}\n.login {\n  background: #fff;\n  width: 520px;\n  max-width: 100%;\n  border-radius: 10px;\n  padding: 32px 52px;\n  z-index: z(\"login\");\n  position: relative;\n  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.5);\n  box-sizing: border-box;\n\n  @include sm {\n    padding: 32px;\n  }\n}\n.login__logo-container {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.login__logo {\n  max-width: 80%;\n}\n\n.buttons-container {\n  display: flex;\n  width: 100%;\n  align-items: center;\n\n  @include sm {\n    flex-direction: column;\n  }\n}\n.buttons-container__row {\n  flex-grow: 1;\n\n  @include sm {\n    width: 100%;\n    text-align: center;\n  }\n\n  ~ .buttons-container__row {\n    @include sm {\n      margin-top: 24px;\n    }\n  }\n}\n\n.login-page__footer {\n  position: relative;\n  z-index: z(\"loginFooter\");\n  padding: 24px;\n}\n.login-page__footer__text {\n  color: #fff;\n  text-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);\n  text-align: center;\n\n  @include sm {\n    font-size: 14px;\n  }\n}\n.mirakl-button {\n  padding-bottom: 1rem;\n  display: flex;\n  flex-direction: column;\n  &__row{\n    padding-top: 1rem;\n    // padding-bottom: 1rem;\n  }\n  .button--mirakl {\n    background-color: #1563a3;\n    width: 100%;\n    color: #fff;\n  }\n}\n","@mixin xxs {\n  // Tiny devices\n  @media (max-width: #{$screen-xxs-max}) {\n    @content;\n  }\n}\n@mixin xs {\n  // Tiny devices\n  @media (max-width: #{$screen-xs-max}) {\n    @content;\n  }\n}\n@mixin sm {\n  // Small devices\n  @media (max-width: #{$screen-sm-max}) {\n    @content;\n  }\n}\n@mixin md {\n  // Medium devices\n  @media (max-width: #{$screen-md-max}) {\n    @content;\n  }\n}\n@mixin lg {\n  // Large devices\n  @media (max-width: #{$screen-lg-max}) {\n    @content;\n  }\n}\n@mixin upper-lg {\n  // Large devices\n  @media (max-width: #{$screen-upper-lg-max}) {\n    @content;\n  }\n}\n@mixin xl {\n  // Extra large devices\n  @media (max-width: #{$screen-xl-max}) {\n    @content;\n  }\n}\n\n@mixin xxs-min {\n  // Tiny devices\n  @media (min-width: #{$screen-xxs-max + 1}) {\n    @content;\n  }\n}\n@mixin xs-min {\n  // Tiny devices\n  @media (min-width: #{$screen-xs-max + 1}) {\n    @content;\n  }\n}\n@mixin sm-min {\n  // Small devices\n  @media (min-width: #{$screen-sm-max + 1}) {\n    @content;\n  }\n}\n@mixin md-min {\n  // Medium devices\n  @media (min-width: #{$screen-md-max + 1}) {\n    @content;\n  }\n}\n@mixin lg-min {\n  // Large devices\n  @media (min-width: #{$screen-lg-max + 1}) {\n    @content;\n  }\n}\n@mixin upper-lg-min {\n  // Large devices\n  @media (min-width: #{$screen-upper-lg-max + 1}) {\n    @content;\n  }\n}\n@mixin xl-min {\n  // Extra large devices\n  @media (min-width: #{$screen-xl-max + 1}) {\n    @content;\n  }\n}\n\n@function z($name) {\n  @if index($z-indexes, $name) {\n    @return (length($z-indexes) - index($z-indexes, $name)) + 1;\n  } @else {\n    @warn 'There is no item \"#{$name}\" in this list; choose one of: #{$z-indexes}';\n    @return null;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
